// import "flatpickr/dist/themes/material_blue.css";
import "flatpickr/dist/themes/dark.css";
import { Portuguese } from "flatpickr/dist/l10n/pt";
import Flatpickr, { DateTimePickerProps } from "react-flatpickr";

export type FlatpickerHourProps = DateTimePickerProps &
  Omit<
    React.ComponentPropsWithoutRef<"input">,
    "children" | "value" | "onChange"
  > & {};

const defaulOptions = {
  locale: Portuguese,
  dateFormat: "d/m/Y H:i",
  enableTime: true,
};

export function FlatpickerHour({
  value,
  onChange,
  options,
  readOnly,
}: FlatpickerHourProps) {
  return (
    <Flatpickr
      options={{
        ...defaulOptions,
        ...options,
        clickOpens: !readOnly,
      }}
      data-enable-time
      value={value}
      //      onChange={onChange}
      onChange={(dates, currentDateString, self) => {
        if (!readOnly) {
          onChange?.(dates, currentDateString, self);
        }
      }}
    />
  );
}
